import React from 'react';
import debounce from 'lodash/debounce';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';

import s from './NumericField.scss';

interface Props {
  label: string;
  value: number;
  onChange: (value: string) => void;
  minValue?: number;
  maxValue?: number;
  sliderStep?: number;
  disabled?: boolean;
}

const NumericField: React.FC<Props> = ({
  label,
  value,
  onChange,
  minValue = 0,
  maxValue = 100,
  sliderStep = 1,
  disabled,
}) => (
  <div className={s['root']}>
    <label className={s['label']}>{label}</label>
    <input
      disabled={disabled}
      className={s['range-slider']}
      value={value}
      type="range"
      step={sliderStep}
      max={maxValue}
      min={minValue}
      onChange={debounce(ev => onChange(ev.target.value), 150, {
        leading: true,
      })}
    />
    <div className={s['range-input-wrapper']}>
      <TextInput
        disabled={disabled}
        id="editor-gallery-range-input"
        className={s['range-input']}
        type={'number'}
        value={value?.toString()}
        onChange={ev => onChange(ev.target.value)}
        min={minValue}
        max={maxValue}
        label={label}
        isLabelHidden
        noBottomSpacing
      />
    </div>
  </div>
);

export default NumericField;
